// Trang chi tiết contest
import React, { useState, useEffect } from "react";
import { Box, Typography, Breadcrumbs } from "@mui/material";
import ContestDetail from "../components/ContestDetail";
import { Contest } from "../../../api/contest";
import { useAlert } from "@/contexts/AlertContext";
import { useParams, useNavigate, Link } from 'react-router-dom';

const ContestDetailPage = () => {
  const [contestDetail, setContestDetail] = useState(null);
  const alert = useAlert();
  const navigate = useNavigate();
  const { contestId: routeContestId } = useParams();

  // Tách contestId và title từ params URL
  const contestId = routeContestId;

  useEffect(() => {
    if (contestId) {
      fetchContestDetail();
    }
  }, [contestId]);

  const fetchContestDetail = async () => {
    try {
      alert.showWait();
      const response = await Contest.getContestDetail(Number(contestId));
      setContestDetail(response);
    } catch (error) {
      console.error("Error loading contest detail:", error);
      alert.error("Error loading contest detail");
    } finally {
      alert.hideWait();
    }
  };

  const handleViewMissionDetail = (mission) => {
    console.log("mission", mission);
    navigate(`/student-workspace/my-contests/${contestId}/${mission.cmid}`);
  };

  const handleBack = () => {
    navigate('/student-workspace/my-contests');
  };

  const handleReload = () => {
    fetchContestDetail();
  };

  if (!contestDetail) return null;

  return (
    <Box>
      <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1 }}>
        <ContestDetail
          data={contestDetail}
          onViewMissionDetail={handleViewMissionDetail}
          onBack={handleBack}
          onReload={handleReload}
        />
      </Box>
    </Box>
  );
};

export default ContestDetailPage; 